<script>
    import Header from "./header.svelte"
    import ResponsiveTable from '../utils/responsivetable3.svelte';
    import { onMount } from 'svelte';
    import { api_host } from "../stores.js";
    import { getToken, doFetch } from '../utils/Fetching.js';
    import { toast_message } from "../utils/toast_message";
    import { formatDateAndTime, sort_functions } from '../utils/format.js';


    const { auth_type, auth_token, domain_code } = getToken();

    onMount(async () => {
		const res = await doFetch(
			api_host + '/api/ex/get/search_address',
			'GET',
			null,
			{ Authorization: `${auth_type} ${auth_token}`, 'Content-Type': 'application/json', 'DomainCode': domain_code }
		);
        if (res.status) {
            let _search_keys = [];
            const { search_addresses } = res;
            for (let i = 0; i < search_addresses.length; i ++) {
                const search_address = search_addresses[i];
                _search_keys.push({
                    "id": i,
                    "d": formatDateAndTime(search_address.created_at),
                    'dt': formatDateAndTime(search_address.created_at).split(' ')[0],
                    "t": search_address.search_key,
                    "ls": search_address.lot_size,
                    "st": search_address.stories,
                    "a": search_address.address,
                    "c": search_address.city,
                    "s": search_address.state
                });
                search_keys = _search_keys;
            }
        } else {
            toast_message(false, res.msg || 'Failed', 2000);
        }
    });

    let table_header_config = [
        {'t': 'Date', 'fm': 'd', 'a': true},
        {'t': 'Typed', 'fm': 't', 'a': true},
        {'t': 'Lot Size (Sq ft)', 'fm': 'ls', 'a': true},
        // {'t': 'Stories', 'fm': 'st', 'a': true},
        // {'t': 'House', 'fm': 'h', 'a': true},
        {'t': 'Address', 'fm': 'a', 'a': true},
        {'t': 'City', 'fm': 'c', 'a': true},
        {'t': 'State', 'fm': 's', 'a': true},
    ];

    let search_keys = [];

    let date_value = '';
</script>


<Header title="Search Log" />
    
<div class="contentholder">
    <div class="giftcardstableholder">
        <ResponsiveTable
            table_data={search_keys} 
            num_per_page={100} 
            show_date_range={true}
            date_filter_param='dt'
            sort_functions={sort_functions}
            bind:table_header_config={table_header_config} 
            bind:total_items={search_keys.length}
            bind:date_value={date_value}
        />
    </div>    
</div>

    
<style>
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .contentholder {
            padding: 0px;
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
        }
    }
</style>